// UI001–UI158 in the approved Australian English copy list (28 October 2026).
// Keep overrides separate from the shared English catalogue used by other sites.
export const AUSTRALIA_UI_MESSAGES = {
  'texts.loginOrRegister': 'Log in or create an account',
  'texts.registerAutoAccountHint': 'Use your email address to log in or create an account.',
  'texts.emailAddress': 'Email address',
  'texts.email': 'Email address',
  'actions.backToHome': 'Back to home',
  'messages.pleaseEnterEmailAddress': 'Enter your email address.',
  'messages.invalidEmailFormat': 'Enter a valid email address.',
  'messages.invalidEmail': 'Enter a valid email address.',
  'texts.enterCode': 'Enter your verification code',
  'texts.sixDigitCode': 'Six-digit code',
  'messages.pleaseEnterSixDigitCode': 'Enter the six-digit code.',
  'messages.sendVerificationCodeFailed': 'Unable to send the verification code. Please try again.',
  'app.pageTitle.register': 'Create account',
  'actions.register': 'Create account',
  'texts.setPassword': 'Password',
  'texts.confirmPassword': 'Confirm password',
  'texts.lineId': 'LINE ID',
  'payment.lineIdLabel': 'LINE ID',
  'texts.imageVerificationCode': 'Code shown in the image',
  'actions.refresh': 'Refresh',
  'messages.pleaseEnterUsername': 'Enter your username.',
  'profile.enterUsername': 'Enter your username.',
  'messages.pleaseEnterEmail': 'Enter your email address.',
  'payment.enterEmail': 'Enter your email address.',
  'messages.pleaseEnterLineId': 'Enter your LINE ID.',
  'payment.enterLineId': 'Enter your LINE ID.',
  'payment.enterLineIdRequired': 'Enter your LINE ID.',
  'messages.passwordLengthError': 'Your password must be 6–18 characters long.',
  'messages.passwordTooShort': 'Your password must contain at least 6 characters.',
  'messages.confirmPasswordTooShort': 'Confirm your password.',
  'messages.passwordMismatch': 'The passwords do not match.',
  'messages.getImageCodeFailed': 'Unable to load the verification image. Please refresh it.',
  'messages.pleaseCompleteImageVerification': 'Complete the image verification first.',
  'messages.registerSuccess': 'Account created',
  'actions.forgotPassword': 'Forgot password?',
  'texts.forgotPassword': 'Forgot password?',
  'texts.forgotPasswordDesc': 'Enter your username or email address. We’ll send a password reset link to the email address on your account.',
  'texts.loginAccount': 'Username or email address',
  'actions.submitResetPassword': 'Send reset link',
  'texts.rememberPassword': 'Remember your password?',
  'messages.resetPasswordSuccess': 'Password reset email sent. Please check your inbox.',
  'messages.resetPasswordFailed': 'Unable to send the password reset email. Please try again later.',
  'payment.cartEmpty': 'Your cart is empty. Add an item to continue to checkout.',
  'payment.itemDeleted': 'Item removed',
  'payment.modifyQuantityFailed': 'Unable to update the quantity. Please try again.',
  'payment.cashierSubtitle': 'Complete payment for your order.',
  'payment.paymentDescription': 'Use the billing address associated with your card or payment method.',
  'payment.otherPaymentTitle': 'Payment methods',
  'payment.otherPaymentsHeading': 'More payment options',
  'payment.otherPaymentsDescription': 'Choose a payment method.',
  'payment.cardholderName': 'Name on card',
  'payment.expiryMonth': 'Expiry month',
  'payment.expiryYear': 'Expiry year',
  'payment.countryRegion': 'Country or region',
  'payment.phone': 'Mobile number',
  'payment.emailAddress': 'Email address',
  'texts.paymentSuccess': 'Payment successful',
  'payment.flyPayResult.explanation': 'Your order status will update once payment is confirmed. If it is still pending, refresh the payment status or view your order.',
  'texts.continueShopping': 'Continue shopping',
  'payment.continueShopping': 'Continue shopping',
  'payment.cashierOrderSummary': 'Order summary',
  'payment.summaryTitleDesktop': 'Order summary',
  'app.tabs.order': 'Find your order',
  'app.pageTitle.orderQuery': 'Find your order',
  'orderQuery.templateTitle': 'Find your order',
  'orderQuery.hint': 'Enter your order number, email address or phone number to find your order.',
  'orderQuery.mobileLabel': 'Phone number used for delivery',
  'orderQuery.mobilePlaceholder': 'Enter the phone number used for delivery',
  'orderQuery.emailLabel': 'Email address',
  'orderQuery.continuePaymentSubtitle': 'Choose a payment method to pay for this order.',
  'orderQuery.confirmContinuePayment': 'Continue to payment',
  'orderQuery.resultCount': { one: '{count} order', other: '{count} orders' },
  'orderQuery.itemCount': { one: '{count} item', other: '{count} items' },
  'texts.goods': { one: '{num} item', other: '{num} items' },
  'texts.orderCenter': 'My orders',
  'texts.gridView': 'Grid',
  'actions.confirmReceive': 'Confirm receipt',
  'actions.goToComment': 'Write a review',
  'actions.viewLogistics': 'Track order',
  'actions.contactService': 'Contact us',
  'actions.applyReturn': 'Request a return',
  'actions.applyRefund': 'Request a refund',
  'texts.orderStates.completed': 'Completed',
  'texts.orderStates.userCancelled': 'Cancelled by you',
  'texts.orderStates.timeout': 'Expired',
  'texts.orderStates.unpaid': 'Awaiting payment',
  'texts.confirmReceiveSuccess': 'Receipt confirmed',
  'texts.refundSuccess': 'Refund requested',
  'texts.aftersalesStates.merchantPending': 'Awaiting store review',
  'texts.aftersalesStates.userShipPending': 'Awaiting your return shipment',
  'texts.aftersalesStates.merchantReceived': 'Return received',
  'texts.aftersalesStates.merchantRefunding': 'Refund in progress',
  'profile.title': 'Account details',
  'profile.email': 'Email address',
  'profile.mobile': 'Mobile number',
  'profile.memberLevel': 'Membership level',
  'profile.memberBenefits': 'Member benefits',
  'profile.memberGrowth': 'Membership progress',
  'profile.address': 'Saved addresses',
  'profile.add': 'Add address',
  'profile.pointsRecords': 'Points history',
  'profile.noPointsRecords': 'No points activity yet.',
  'profile.coupons': 'My coupons',
  'profile.couponType': 'Coupon type',
  'profile.couponCondition': 'Conditions',
  'profile.couponIssueType': 'Offer source',
  'profile.issueBackend': 'Issued by the store',
  'profile.issueSignup': 'Welcome offer',
  'profile.issueInvite': 'Referral reward',
  'profile.stackableStatus': 'Can be combined',
  'profile.stackableYes': 'Yes',
  'profile.stackableNo': 'No',
  'profile.validityStart': 'Valid from',
  'profile.validityEnd': 'Valid until',
  'payment.detailAddress': 'Street address',
  'addAddressModal.detailAddress': 'Street address',
  'payment.cityCounty': 'Suburb or town',
  'addAddressModal.cityCounty': 'Suburb or town',
  'addAddressModal.countryRegion': 'Country or region',
  'addAddressModal.phone': 'Mobile number',
  'payment.postalCode': 'Postcode',
  'payment.deleteConfirm': 'Delete address?',
  'profile.deleteConfirm': 'Delete address?',
  'actions.reselectOptions': 'Change options',
  'texts.allOptionsUnavailable': 'All options are unavailable',
  'texts.outOfStockLabel': 'Out of stock',
  'reviews.writeReview': 'Write a review',
  'reviews.star': { one: 'star', other: 'stars' },
  'reviews.noReviews': 'No reviews yet',
  'messages.collectSuccess': 'Added to wishlist',
  'messages.cancelCollectSuccess': 'Removed from wishlist',
  'actions.close': 'Close',
  'texts.copySuccess': 'Copied to clipboard',
  'messages.copySuccess': 'Copied to clipboard',
  'messages.uploadImgIsUnValidateType': 'Upload a JPG, JPEG or PNG image.',
  'messages.uploadImgIsToLarge': 'Choose an image no larger than 2 MB.',
  'actions.authorizationCode': 'Authorisation code',
  'actions.copyAuthCode': 'Copy authorisation code',
}

export const AUSTRALIA_ACCOUNT_DESCRIPTION = 'Track your orders and manage your details in one place.'

// Exact legacy template defaults only. Custom CMS and product copy is preserved.
export const AUSTRALIA_UI_TEXT_REPLACEMENTS = {
  'SERVICE CENTER': 'Help centre',
  'Service Center': 'Help centre',
  'Service Centre': 'Help centre',
  'Sign up and save': 'Create your account',
  'Subscribe to get special offers, free giveaways, and once-in-a-lifetime deals.': AUSTRALIA_ACCOUNT_DESCRIPTION,
  'Save your favourites, track your orders and manage your details in one place.': AUSTRALIA_ACCOUNT_DESCRIPTION,
  'Keep your favourites, track your orders and manage your details in one place.': AUSTRALIA_ACCOUNT_DESCRIPTION,
  'Claim Offer >': 'View offer',
  'Secure checkout\n100% safe': 'Secure checkout',
  'Secure checkout 100% safe': 'Secure checkout',
  'September 28 | 5 min read': '28 Sep | 5 min read',
}
